import ProjectTypes from './ProjectTypes';

export default {
  [ProjectTypes.CLASSIC]: 'extensionFeeClassic',
  [ProjectTypes.SWIFT]: 'extensionFeeSwift',
  [ProjectTypes.PRO]: 'extensionFeePro',
  [ProjectTypes.OCCASION_BOOK]: 'extensionFeeOccasionBook',
};
